/* //Clube de Baneficios
import { z } from 'zod';

export const validateCPF = (cpf: string): boolean => {
  const cleaned = cpf.replace(/\D/g, '');

  if (cleaned.length !== 11) return false;
  if (/^(\d)\1+$/.test(cleaned)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleaned.charAt(i)) * (10 - i);
  }
  let digit = 11 - (sum % 11);
  if (digit >= 10) digit = 0;
  if (digit !== parseInt(cleaned.charAt(9))) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleaned.charAt(i)) * (11 - i);
  }
  digit = 11 - (sum % 11);
  if (digit >= 10) digit = 0;
  if (digit !== parseInt(cleaned.charAt(10))) return false;

  return true;
};

export const validateCNPJ = (cnpj: string): boolean => {
  if (!cnpj) return false;

  const cleaned = cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

  // CNPJ precisa ter 14 caracteres
  if (cleaned.length !== 14) return false;

  // Novo formato: 12 primeiros alfanuméricos + 2 últimos numéricos (DV)
  const regexNovo = /^[A-Z0-9]{12}\d{2}$/;
  const regexAntigo = /^\d{14}$/;

  if (!regexNovo.test(cleaned) && !regexAntigo.test(cleaned)) {
    return false;
  }

  // Converte caracteres em valores numéricos (para cálculo do DV)
  const toNumeric = (char: string): number => {
    if (/[0-9]/.test(char)) return parseInt(char);
    // A=10, B=11, ..., Z=35
    return char.charCodeAt(0) - 55;
  };

  // Converte todos os 14 caracteres para números
  const digits = cleaned.split('').map(toNumeric);

  // Pesos oficiais para o cálculo do CNPJ (módulo 11)
  const peso1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const peso2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  // Calcula o primeiro dígito verificador
  const calcDV = (nums: number[], pesos: number[]): number => {
    const soma = nums.reduce((acc, num, i) => acc + num * pesos[i], 0);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  const dv1 = calcDV(digits.slice(0, 12), peso1);
  const dv2 = calcDV([...digits.slice(0, 12), dv1], peso2);

  return dv1 === digits[12] && dv2 === digits[13];
};

export const validateAge = (birthDate: string): boolean => {
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age >= 18;
};

export const registerSchema = z
  .object({
    nome: z
      .string()
      .min(3, 'Nome deve ter pelo menos 3 caracteres')
      .regex(/^[a-zA-ZÀ-ÿ\s]+$/, 'Nome deve conter apenas letras'),
    cpf: z
      .string()
      .min(11, 'CPF deve ter 11 dígitos')
      .refine(validateCPF, 'CPF inválido'),

    email: z.string().email('E-mail inválido'),
    confirmarEmail: z.string(),
    senha: z
      .string()
      .min(6, 'A senha deve ter pelo menos 6 caracteres')
      .regex(/[0-9]/, 'A senha deve conter pelo menos um número')
      .regex(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula')
      .regex(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula')
      .regex(
        /[!@#$%^&*]/,
        'A senha deve conter pelo menos um caractere especial',
      ),
    confirmarSenha: z.string(),
    genero: z.string(),
    celular: z
      .string()
      .min(11, 'Celular deve ter pelo menos 11 dígitos')
      .max(11, 'Celular deve ter no máximo 11 dígitos')
      .regex(/^\d{10,11}$/, 'Celular deve conter apenas números'),
    dataNascimento: z
      .string()
      .optional()
      .refine(
        val => !val || validateAge(val),
        'Você deve ter pelo menos 18 anos',
      ),
    estado: z.string(),
    termos: z
      .boolean()
      .refine(val => val === true, 'Você deve aceitar os termos de uso'),
    ofertas: z.boolean(),
    sms: z.boolean(),
    origem: z.string(),
    grupo: z.string(),
    empresa: z.string(),
  })
  .refine(data => data.email === data.confirmarEmail, {
    message: 'Os e-mails não coincidem',
    path: ['confirmarEmail'],
  })
  .refine(data => data.senha === data.confirmarSenha, {
    message: 'As senhas não coincidem',
    path: ['confirmarSenha'],
  });

export const loginSchema = z.object({
  email: z.string().email('E-mail inválido'),
  senha: z.string().min(1, 'Senha é obrigatória'),
});

export const loginCpfSchema = z.object({
  cpf: z
    .string()
    .min(11, 'CPF deve ter 11 dígitos')
    .refine(validateCPF, 'CPF inválido'),
  senha: z.string().min(1, 'Senha é obrigatória'),
});

export const emailSchema = z.string().email('Formato de e-mail inválido');

export type RegisterFormData = z.infer<typeof registerSchema>;
export type LoginFormData = z.infer<typeof loginSchema>; // Para email
export type LoginCpfFormData = z.infer<typeof loginCpfSchema>; // Para CPF
 */

//Clube de Benefícios
import { z } from 'zod';

// ✅ CPFs de teste Apple (sincronizados com backend)
const APPLE_TEST_CPFS = ['99988877766', '11122233344', '55566677788'];

export const validateCPF = (cpf: string): boolean => {
  const cleaned = cpf.replace(/\D/g, '');

  if (APPLE_TEST_CPFS.includes(cleaned)) {
    return true;
  }

  if (cleaned.length !== 11) return false;
  if (/^(\d)\1+$/.test(cleaned)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleaned.charAt(i)) * (10 - i);
  }
  let digit = 11 - (sum % 11);
  if (digit >= 10) digit = 0;
  if (digit !== parseInt(cleaned.charAt(9))) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleaned.charAt(i)) * (11 - i);
  }
  digit = 11 - (sum % 11);
  if (digit >= 10) digit = 0;
  if (digit !== parseInt(cleaned.charAt(10))) return false;

  return true;
};

export const validateCNPJ = (cnpj: string): boolean => {
  if (!cnpj) return false;

  const cleaned = cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

  // CNPJ precisa ter 14 caracteres
  if (cleaned.length !== 14) return false;

  // Novo formato: 12 primeiros alfanuméricos + 2 últimos numéricos (DV)
  const regexNovo = /^[A-Z0-9]{12}\d{2}$/;
  const regexAntigo = /^\d{14}$/;

  if (!regexNovo.test(cleaned) && !regexAntigo.test(cleaned)) {
    return false;
  }

  // Converte caracteres em valores numéricos (para cálculo do DV)
  const toNumeric = (char: string): number => {
    if (/[0-9]/.test(char)) return parseInt(char);
    // A=10, B=11, ..., Z=35
    return char.charCodeAt(0) - 55;
  };

  // Converte todos os 14 caracteres para números
  const digits = cleaned.split('').map(toNumeric);

  // Pesos oficiais para o cálculo do CNPJ (módulo 11)
  const peso1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const peso2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  // Calcula o primeiro dígito verificador
  const calcDV = (nums: number[], pesos: number[]): number => {
    const soma = nums.reduce((acc, num, i) => acc + num * pesos[i], 0);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  const dv1 = calcDV(digits.slice(0, 12), peso1);
  const dv2 = calcDV([...digits.slice(0, 12), dv1], peso2);

  return dv1 === digits[12] && dv2 === digits[13];
};

export const parseBrDate = (value?: string): Date | null => {
  if (!value || !/^(\d{2})\/(\d{2})\/(\d{4})$/.test(value)) {
    return null;
  }

  const [day, month, year] = value.split('/').map(Number);
  const date = new Date(year, month - 1, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
};

export const isDateInFuture = (date: Date): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const normalizedDate = new Date(date);
  normalizedDate.setHours(0, 0, 0, 0);

  return normalizedDate > today;
};

export const validateBirthDate = (value: string): boolean => {
  const date = parseBrDate(value);

  return !!date && !isDateInFuture(date);
};

export const validateDateStringNotFuture = (value: string): boolean => {
  const date = new Date(value);

  return !Number.isNaN(date.getTime()) && !isDateInFuture(date);
};
export const validateAge = (birthDate: string): boolean => {
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age >= 18;
};

export const registerSchema = z
  .object({
    nome: z
      .string()
      .min(3, 'Nome deve ter pelo menos 3 caracteres')
      .regex(/^[a-zA-ZÀ-ÿ\s]+$/, 'Nome deve conter apenas letras'),
    cpf: z
      .string()
      .min(11, 'CPF deve ter 11 dígitos')
      .refine(validateCPF, 'CPF inválido'), // ✅ Usa validateCPF com bypass

    email: z.string().email('E-mail inválido'),
    confirmarEmail: z.string(),
    senha: z
      .string()
      .min(6, 'A senha deve ter pelo menos 6 caracteres')
      .regex(/[0-9]/, 'A senha deve conter pelo menos um número')
      .regex(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula')
      .regex(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula')
      .regex(
        /[!@#$%^&*]/,
        'A senha deve conter pelo menos um caractere especial',
      ),
    confirmarSenha: z.string(),
    genero: z.string(),
    celular: z
      .string()
      .min(11, 'Celular deve ter pelo menos 11 dígitos')
      .max(11, 'Celular deve ter no máximo 11 dígitos')
      .regex(/^\d{10,11}$/, 'Celular deve conter apenas números'),
    dataNascimento: z
      .string()
      .optional()
      .refine(
        val => !val || validateAge(val),
        'Você deve ter pelo menos 18 anos',
      ),
    estado: z.string(),
    termos: z
      .boolean()
      .refine(val => val === true, 'Você deve aceitar os termos de uso'),
    ofertas: z.boolean(),
    sms: z.boolean(),
    origem: z.string(),
    grupo: z.string(),
    empresa: z.string(),
  })
  .refine(data => data.email === data.confirmarEmail, {
    message: 'Os e-mails não coincidem',
    path: ['confirmarEmail'],
  })
  .refine(data => data.senha === data.confirmarSenha, {
    message: 'As senhas não coincidem',
    path: ['confirmarSenha'],
  });

export const loginSchema = z.object({
  email: z.string().email('E-mail inválido'),
  senha: z.string().min(1, 'Senha é obrigatória'),
});

export const loginCpfSchema = z.object({
  cpf: z
    .string()
    .min(11, 'CPF deve ter 11 dígitos')
    .refine(validateCPF, 'CPF inválido'), // ✅ Usa validateCPF com bypass
  senha: z.string().min(1, 'Senha é obrigatória'),
});

export const emailSchema = z.string().email('Formato de e-mail inválido');

export type RegisterFormData = z.infer<typeof registerSchema>;
export type LoginFormData = z.infer<typeof loginSchema>; // Para email
export type LoginCpfFormData = z.infer<typeof loginCpfSchema>; // Para CPF

// Exportar constantes uteis
export { APPLE_TEST_CPFS };
